"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchCalendar = exports.setMonth = exports.setSelectedCalendar = void 0;
function setSelectedCalendar(selectedCalendar) {
    return {
        type: "SetSelectedCalendar",
        payload: selectedCalendar,
    };
}
exports.setSelectedCalendar = setSelectedCalendar;
function setMonth(year, month) {
    return {
        type: "SetMonth",
        payload: { year: year, month: month },
    };
}
exports.setMonth = setMonth;
function dispatchCalendar(action) {
    return {
        type: "DispatchCalendar",
        action: action,
    };
}
exports.dispatchCalendar = dispatchCalendar;
//# sourceMappingURL=main-actions.js.map